import commonService from 'utils/commonService';
import apiService from 'bff/services/apiService';
import { BaseRes } from 'bff/models/base/baseRes';
import { NewList } from 'bff/models/new';
import { ReturnCode } from 'constants/enums/returnCode.enum';
import { Article } from 'bff/models/new/article';

const fetchInitSetting = async () => {
  const reqConfig = commonService.getReqConfig();
  const newReq = commonService.getApiReqData({ INFO_TYPE: 'ALL' });

  const result = await Promise.all([
    apiService.fetchNewList(newReq, reqConfig)

  ]).then(([newListRes]) => {
    const newListBaseRes: BaseRes<NewList> = { ...newListRes };
    const res = {
      newList: { ...newListBaseRes.TRANRS }
    };
    return res;
  });

  return result;
};

const fetchArticle = async (sn: number) => {
  const baseReq = commonService.getApiReqData({ ARTICLE_SN: sn });
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fetchArticle(baseReq, reqConfig).then((res: BaseRes<Article>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
};

export default {
  fetchInitSetting,
  fetchArticle
};
